import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=72c7a522&scoped=true&"
import script from "./logisticsInfo.vue?vue&type=script&lang=js&"
export * from "./logisticsInfo.vue?vue&type=script&lang=js&"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=72c7a522&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7a522",
  null
  
)

export default component.exports